import {IJobDetails,IJobDetailsActionTypes,IJobActionCreator} from 'models/IJobState';

const initialState:IJobDetails = {}

const reducer = (state = initialState, { type, payload }: IJobActionCreator) => {
    switch (type) {
      case IJobDetailsActionTypes.FETCH_JOB_DETAILS_REQUEST:
        return {
          ...state,
          data:{},
        }
      case IJobDetailsActionTypes.FETCH_JOB_DETAILS_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;